import { Component, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { InspectionService, ApplicationService } from '../../shared/services/index';
import { ReportPdfListPageComponent } from '../../shared/pages/index';

@Component({
    templateUrl: '../../shared/pages/report-list/report-pdf-list.component.html',
    standalone: false
})
export class InspectionReportPdfListPageComponent extends ReportPdfListPageComponent {
  constructor(
    public reportService: InspectionService,
    public applicationService: ApplicationService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public location: Location,
    public cdf: ChangeDetectorRef
  ) {
    super(reportService, applicationService, router, activatedRoute, location, cdf);
  }
}
